import React from "react";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import AppRouter from "./navigation/AppRouter";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const theme = createTheme({
  palette: {
    primary: {
      main: "#75BD1D",
    },
  },
});

function App() {
  return (
    <>
      <GoogleOAuthProvider clientId="624546562658-fee5738um6dd08d20rhn5js3stea849c.apps.googleusercontent.com">
        <ThemeProvider theme={theme}>
          <AppRouter />
        </ThemeProvider>
      </GoogleOAuthProvider>
      <ToastContainer />
    </>
  );
}

export default App;
